import { useFragment, useLazyLoadQuery } from "react-relay";
import { graphql } from "relay-runtime";
import { TagFragment$key } from "./__generated__/TagFragment.graphql";
import { Badge, BadgeProps } from "@/kit/ui/badge";
import { TagQuery as TagQueryType } from "./__generated__/TagQuery.graphql";
import { XIcon } from "@/icons";
import { MouseEventHandler } from "react";

const TagFragment = graphql`
  fragment TagFragment on Tag {
    name
  }
`;

interface TagProps extends BadgeProps {
  tag: TagFragment$key;
  onRemove?: MouseEventHandler;
}

export default function Tag({
  tag: tagFragment,
  onRemove,
  ...props
}: TagProps) {
  const { name } = useFragment(TagFragment, tagFragment);
  return (
    <Badge {...props}>
      {name}
      {onRemove && (
        <span role="button" className="hover:cursor-pointer">
          <XIcon className="w-4 h-4" onClick={onRemove} />
        </span>
      )}
    </Badge>
  );
}

const TagQuery = graphql`
  query TagQuery($id: ID!) {
    node(id: $id) {
      ... on Tag {
        ...TagFragment
      }
    }
  }
`;

interface LazyTagProps extends Omit<TagProps, "tag"> {
  id: ID;
}

export function LazyTag({ id, ...props }: LazyTagProps) {
  const data = useLazyLoadQuery<TagQueryType>(
    TagQuery,
    { id },
    { fetchPolicy: "store-or-network" },
  );

  if (!data) return;
  return <Tag tag={data.node} {...props} />;
}

export function SkeletonTag() {
  return <Badge className="rounded-full w-16 h-4" />;
}
